// extracted by mini-css-extract-plugin
module.exports = {"sentinel":"Connected_sentinel__kufv8","pageStatus":"Connected_pageStatus__7R_R5"};